import React, { Fragment } from "react";

import { AdministrationCard } from "@common/components/AdministrationCard/AdministrationCard";
import Button from "@common/components/Button/Button";
import { useModal } from "@common/components/Modal/Modal";
import { App } from "@common/models";
import DeleteAppModalBody from "@main/pages/Administration/components/ModalBody/DeleteAppModalBody";

interface DeleteAppCardProps {
  app: App;
  deleteApp: (appId: string) => Promise<void>;
  loading: boolean;
  disabled: boolean;
}

export function DeleteAppCard({ app, deleteApp, loading, disabled }: DeleteAppCardProps): JSX.Element {
  const { Modal: DeleteAppModal, modalProps, setActive } = useModal({ size: "narrow" });

  const handleAppDelete = async () => {
    await deleteApp(app.id);
    setActive(false);
  };

  return (
    <Fragment>
      <AdministrationCard
        title={"Danger zone"}
        subtitle={
          "If deactivating an app is not enough, as an admin you can permanently remove this app from your workspace. This action cannot be undone."
        }
      >
        <Button
          size="small"
          color="red"
          disabled={disabled}
          onClick={() => setActive(true)}
          tooltip={{
            disabled: !disabled,
            position: "top",
            text: "Only admins can delete apps",
          }}
        >
          {"Delete this app"}
        </Button>
      </AdministrationCard>

      <DeleteAppModalBody
        appName={app?.name}
        deleteApp={handleAppDelete}
        loading={loading}
        Modal={DeleteAppModal}
        internalProps={modalProps}
      />
    </Fragment>
  );
}
